// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"76":"common","945":"dashboard"}[chunkId] || chunkId) + "-legacy." + {"76":"f936166f","249":"4ffceb29","945":"80e799fa"}[chunkId] + ".js";
};